/**
 * 财务系统
 *
 */
import Layout from '@/layout'


const payCenterRouter = {
  DriversNeedAudited: () => // 垫付/风控任务-垫付需审核司机
    import('@/views/pay-center/advance_risk_task/aduit-driver/index'),
}

const payCenterRouters = [
	{
		path: '/company-cash',
		component: Layout,
		name: 'CompanyCash',
		children: [
			{
				path: '/cash-problem-invoice',
				component: () => import('@/views/pay-center/company/cash-problem-invoice.vue'),
				name: 'CashProblemInvoice',
				hidden: true,
				meta: { title: '发票问题详情' }
			},
		]
	}
]
export {
  payCenterRouter,
  payCenterRouters
}
